import { createHelpIcon } from 'atg/components/HelpIcon';
import StickyTemplate from 'atg/vendor/StickyTemplate/1.0/StickyTemplate';
import { settings } from 'shared/redux/selectors';
import { getStore } from 'shared/redux/store';
import { formatMoney } from 'shared/utils/money';
import * as Text from 'shared/utils/Text';

const $ = window.$;

function renderDividends(api, $conditions) {
  const $dividends = $conditions.find('.dividends');
  const $dividendsTableBody = $dividends.find('table tbody');
  $dividendsTableBody.empty();

  const numberOfPayouts = api.resultInformation.getNumberOfPayouts();
  if (numberOfPayouts > 0) {
    $dividends.show();

    for (let idx = 0; idx < numberOfPayouts; idx++) {
      const payout = api.resultInformation.getPayout(idx);
      const dividend = payout.getPayoutAmount();

      let numberOfCorrects = payout.getNumberOfCorrects();
      if (api.resultInformation.getResultType() === 'FivePlus') {
        const prizeGroup = payout.getPrizeGroup();
        if (prizeGroup === 'FiveInOrderPrize') {
          numberOfCorrects = Text.get('ranking-dividends-fiveplus-all-correct');
        } else if (prizeGroup === 'FourOfFivePrize') {
          numberOfCorrects = Text.get(
            'ranking-dividends-fiveplus-four-correct',
          );
        } else {
          numberOfCorrects = Text.get(
            'ranking-dividends-fiveplus-first-n-correct',
            numberOfCorrects,
          );
        }
      }

      const $row = StickyTemplate.jq('bottom-conditions-ranking-dividend-row', {
        '.number-of-corrects': numberOfCorrects,
        '.dividend': formatMoney(dividend.getSum(), dividend.getCurrency()),
      });

      $dividendsTableBody.append($row);
    }
  }
}

function handleResultsFivePlus(
  api,
  $conditions,
  toggleResultRowHandler,
  showAllResultsHandler,
  hideAllResultsHandler,
) {
  const numberOfRows = api.raceInformation.getNumberOfRaces();

  if (numberOfRows === 0) {
    return false;
  }
  const betConfig = api.betInformation.getBetConfig();
  const $fiveplusResults = $conditions.find('.fiveplus-results');
  $fiveplusResults.show();

  const $table = $fiveplusResults.find('table');
  const $tableBody = $table.find('tbody');

  $tableBody.empty();

  let showAllRows = true;

  for (let rowIdx = 0; rowIdx < numberOfRows; rowIdx++) {
    const rowNumber = rowIdx + 1;
    const props = {
      '.place': Text.get('ranking-fiveplus-place-number', rowNumber),
    };
    const showRow = betConfig.getShowResultRow(rowIdx);
    if (showRow) {
      const row = api.resultInformation.getRow(rowIdx);
      const horses = row ? row.getWinners() : [];
      props['.horse'] = horses.join(', ');
    } else {
      props['.horse'] = Text.get('ranking-fiveplus-horse-hidden');
      showAllRows = false;
    }

    const $row = StickyTemplate.jq(
      'bottom-conditions-ranking-fiveplus-results-row',
      props,
    );

    const $checkbox = $row.find('input[type=checkbox]');
    $checkbox.data('row-index', rowIdx);
    $checkbox.hide();

    if (showRow) {
      $checkbox.prop({ checked: true });
    }

    $checkbox.event('change', toggleResultRowHandler);
    $tableBody.append($row);
  }

  const $toggleLink = $fiveplusResults.find('.toggle-all-wrapper');
  const $toggleText = $toggleLink.find('.toggle-all');
  const $toggleIcon = $toggleLink.find('.sprite');

  if (showAllRows) {
    $toggleText.text(Text.get('ranking-results-show-none'));
    $toggleIcon.removeClass('view-result').addClass('view-result-hidden');
    $toggleLink.reevent('click', hideAllResultsHandler);
    renderDividends(api, $conditions);
  } else {
    $toggleText.text(Text.get('ranking-results-show-all'));
    $toggleIcon.removeClass('view-result-hidden').addClass('view-result');
    $toggleLink.reevent('click', showAllResultsHandler);
  }
  return true;
}

// Double/Trio bet type
function handleResultsSingleRaceBetType(
  api,
  $conditions,
  toggleResultRowHandler,
  showAllResultsHandler,
  hideAllResultsHandler,
) {
  const numberOfOdds = api.resultInformation.getNumberOfOdds();

  if (numberOfOdds === 0) {
    return false;
  }

  const betConfig = api.betInformation.getBetConfig();
  const resultType = api.resultInformation.getResultType();
  const $odds = $conditions.find('.odds');
  let $row;
  let $cell;
  let showAllRows = true;

  $odds.show();

  const rowCellHeadingTextID =
    resultType === 'Trio' ? 'ranking-odds-place' : 'ranking-odds-leg';
  const cellHeadingTextID =
    resultType === 'Trio'
      ? 'ranking-odds-place-number'
      : 'ranking-odds-leg-number';
  const showCheckboxes = resultType === 'Double';

  const $table = $odds.find('table');
  const $tableHead = $table.find('thead');
  const $tableBody = $table.find('tbody');

  $tableHead.empty();
  $tableBody.empty();

  $row = $('<tr/>').appendTo($tableBody);
  $cell = $('<td/>').text(Text.get(rowCellHeadingTextID)).appendTo($row);

  if (showCheckboxes) {
    $cell = $('<td/>').text(Text.get('ranking-odds-status')).appendTo($row);
    $cell = $('<td/>').text(Text.get('ranking-odds-show')).appendTo($row);
  }

  for (let idx = 0; idx < numberOfOdds; idx++) {
    const text =
      numberOfOdds > 1
        ? Text.get('ranking-odds-combination', idx + 1)
        : Text.get('ranking-odds-combination-single');
    $cell = $('<td/>').appendTo($row);
    $cell.text(text);
  }

  let combinationLength = 0;

  for (let idx = 0; idx < numberOfOdds; idx++) {
    const odds = api.resultInformation.getOdds(idx);
    combinationLength = Math.max(
      combinationLength,
      odds.getCombinationLength(),
    );
  }

  for (let rowIdx = 0; rowIdx < combinationLength; rowIdx++) {
    $row = $('<tr/>').appendTo($tableBody);
    $cell = $('<td/>').appendTo($row);

    const rowNumber = rowIdx + 1;
    const cellHeadingSpecificTextID = `${cellHeadingTextID}-${rowNumber}`;
    const text = Text.hasText(cellHeadingSpecificTextID)
      ? Text.get(cellHeadingSpecificTextID)
      : Text.get(cellHeadingTextID, rowNumber);

    $cell.text(text);
    const showRow = betConfig.getShowResultRow(rowIdx);

    if (showCheckboxes) {
      $cell = $('<td/>').appendTo($row);
      const row = api.resultInformation.getRow(rowIdx);
      const status = row?.isComplete() ? 'complete' : 'none';
      $cell.text(Text.get(`ranking-odds-status_${status}`));
    }

    $cell = StickyTemplate.jq(
      'bottom-conditions-ranking-odds-cell-show',
    ).appendTo($row);

    if (!showCheckboxes) {
      $cell.css({ display: 'none' });
    }

    const $checkbox = $cell.find('input[type=checkbox]');
    $checkbox.data('row-index', rowIdx);

    if (showRow) {
      $checkbox.prop({ checked: true });
    }

    $checkbox.event('change', toggleResultRowHandler);

    $tableBody.append($row);

    if (!showRow) {
      showAllRows = false;
    }

    for (let idx = 0; idx < numberOfOdds; idx++) {
      $cell = $('<td/>').appendTo($row);
      const odds = api.resultInformation.getOdds(idx);
      const combination = odds.getCombination();
      let value;

      if (showRow) {
        value =
          idx < combination.length && combination[rowIdx] !== 0
            ? combination[rowIdx]
            : '';
      } else {
        value = Text.get('ranking-odds-combination-hidden');
      }

      $cell.text(value);
    }
  }

  $row = $('<tr/>').appendTo($tableBody);
  $cell = $('<td/>').appendTo($row);
  $cell.text(Text.get('ranking-odds-odds'));

  if (showCheckboxes) {
    $cell = $('<td/>').appendTo($row);
    $cell = $('<td/>').appendTo($row);
  }

  for (let idx = 0; idx < numberOfOdds; idx++) {
    const odds = api.resultInformation.getOdds(idx);
    const text = showAllRows
      ? odds.getOdds()
      : Text.get('ranking-odds-odds-hidden');
    $cell = $('<td/>').appendTo($row);
    $cell.text(text);
  }

  const $toggleLink = $odds.find('.toggle-all-wrapper');
  const $toggleText = $toggleLink.find('.toggle-all');
  const $toggleIcon = $toggleLink.find('.sprite');

  if (showAllRows) {
    $toggleText.text(Text.get('ranking-results-show-none'));
    $toggleIcon.removeClass('view-result').addClass('view-result-hidden');
    $toggleLink.reevent('click', hideAllResultsHandler);
  } else {
    $toggleText.text(Text.get('ranking-results-show-all'));
    $toggleIcon.removeClass('view-result-hidden').addClass('view-result');
    $toggleLink.reevent('click', showAllResultsHandler);
  }

  return true;
}

function handleResultsMultiRaceBetType(
  api,
  $conditions,
  toggleResultRowHandler,
  showAllResultsHandler,
  hideAllResultsHandler,
) {
  const $winnersAndValues = $conditions.find('.winners-and-values');
  const $dividendsPerHorse = $conditions.find('.dividends-per-horse');
  const $preliminaryDividendPerHorse = $conditions.find(
    '.preliminary-dividend-per-horse',
  );
  const $tableBody = $winnersAndValues.find('table tbody');

  const numberOfRows = api.raceInformation.getNumberOfRaces();

  if (numberOfRows === 0) {
    return false;
  }

  let showAllRows = false;
  let previousRowComplete = false;

  $tableBody.empty();

  let dividendPerHorseLegNumber = 0;

  if (numberOfRows > 0) {
    showAllRows = true;

    $winnersAndValues.show();

    for (let idx = 0; idx < numberOfRows; idx++) {
      const row = api.resultInformation.getRow(idx);
      const chanceOfCorrect = api.rowsLeftInformation.getChanceOfCorrect(idx);
      const legNumber = idx + 1;
      let winners;
      let value;
      let status;

      if (row) {
        value = row.getValue();
        winners = row.getWinners();
        status = row.isComplete() ? 'complete' : 'incomplete';
      } else {
        value = false;
        winners = [];
        status = 'incomplete';
      }

      const showRow = api.betInformation.getBetConfig().getShowResultRow(idx);

      if (
        dividendPerHorseLegNumber === 0 && // not yet set, and
        showAllRows && // all previous rows shown, and
        previousRowComplete && // previous leg complete, and
        (!showRow || status !== 'complete') // not showing or not complete
      ) {
        dividendPerHorseLegNumber = legNumber;
      }

      // caching this row's status
      previousRowComplete = status === 'complete';

      const props = {
        '.leg': legNumber,
        '.status': Text.get(`ranking-results-status_${status}`),
      };

      if (showRow) {
        props['.winner'] = winners.join(', ');

        if (showAllRows) {
          if (value) {
            props['.value'] = formatMoney(value.getSum(), value.getCurrency());
          }

          if (chanceOfCorrect) {
            const nrStillPos = chanceOfCorrect.getNrOfCorrectStillPossible();
            const color = chanceOfCorrect.getColor();
            const colorCodes = {
              green: '#19bf40',
              red: '#d20000',
              grey: '#646464',
            };
            const colorHex = colorCodes[color];

            props['.correct'] = $('<span />').text(`${nrStillPos} rätt`).css({
              backgroundColor: colorHex,
              color: 'white',
              borderRadius: '9px',
              fontWeight: 'bold',
              display: 'block',
              width: '40px',
              textAlign: 'center',
              paddingTop: '3px',
              paddingBottom: '3px',
            });
          } else {
            props['.correct'] = $('<span />');
          }
        } else {
          props['.correct'] = $('<em/>').text(
            'kräver visning av föregående avdelningar',
          );
        }
      } else {
        props['.winner'] = $('<em/>').text(
          Text.get('ranking-results-winner-hidden'),
        );
        props['.value'] = $('<em/>').text(
          Text.get('ranking-results-value-hidden'),
        );
        props['.correct'] = $('<em/>').text(
          Text.get('ranking-results-value-hidden'),
        );
        showAllRows = false;
      }

      const $row = StickyTemplate.jq(
        'bottom-conditions-ranking-winners-and-values-row',
        props,
      );
      const $checkbox = $row.find('input[type=checkbox]');
      $checkbox.data('row-index', idx);

      if (showRow) {
        $checkbox.prop({ checked: true });
      }

      $checkbox.event('change', toggleResultRowHandler);
      $tableBody.append($row);
    }
  }

  if (dividendPerHorseLegNumber > 0) {
    for (let i = dividendPerHorseLegNumber; i < numberOfRows; i++) {
      if (
        api.betInformation.getBetConfig().getShowResultRow(i) &&
        api.resultInformation.getRow(i)?.isComplete()
      ) {
        // cancel it, because there's a showing complete leg further down the list
        dividendPerHorseLegNumber = 0;
        break;
      }
    }
  }

  let dividendPerHorse;
  let preliminaryDividendPerHorse = [];
  let allHorses = [];
  let selectedHorses = [];
  if (dividendPerHorseLegNumber > 0) {
    dividendPerHorse = api.gameInformation.getDividendPerHorseForLeg(
      dividendPerHorseLegNumber,
    );

    const secondLastChance = api.rowsLeftInformation.getChanceOfCorrect(
      dividendPerHorseLegNumber - 2,
    );
    const horsesRowsLeft = api.rowsLeftInformation.getRow(
      dividendPerHorseLegNumber,
    );
    allHorses = api.betInformation
      .getRow(dividendPerHorseLegNumber - 1)
      .getOrder();
    if (
      secondLastChance &&
      secondLastChance.getNrOfCorrectStillPossible() === numberOfRows &&
      horsesRowsLeft
    ) {
      selectedHorses = allHorses.filter(
        (_startNumber, index) => horsesRowsLeft.getRowsLeft(index) > 0,
      );
    }
  }

  if (dividendPerHorseLegNumber === numberOfRows) {
    preliminaryDividendPerHorse =
      api.rowsLeftInformation.getPreliminaryDividendPerHorse();
  }

  const $toggleLink = $winnersAndValues.find('.toggle-all-wrapper');
  const $toggleText = $toggleLink.find('.toggle-all');
  const $toggleIcon = $toggleLink.find('.sprite');

  if (showAllRows) {
    $toggleText.text(Text.get('ranking-results-show-none'));
    $toggleIcon.removeClass('view-result').addClass('view-result-hidden');
    $toggleLink.reevent('click', hideAllResultsHandler);
    if (api.resultInformation.getRow(numberOfRows - 1)?.isComplete()) {
      renderDividends(api, $conditions);
    }
  } else {
    $toggleText.text(Text.get('ranking-results-show-all'));
    $toggleIcon.removeClass('view-result-hidden').addClass('view-result');
    $toggleLink.reevent('click', showAllResultsHandler);
  }

  if (dividendPerHorse) {
    const numberOfDividendsPerHorse = dividendPerHorse.getNumberOfDividends();
    if (numberOfDividendsPerHorse > 0) {
      const $dividendsPerHorseTableBody =
        $dividendsPerHorse.find('table tbody');
      $dividendsPerHorseTableBody.empty();

      $dividendsPerHorse.show();

      const isLastLeg = dividendPerHorseLegNumber === numberOfRows;
      const isLastLegAndIsComplete =
        isLastLeg &&
        api.resultInformation.getRow(numberOfRows - 1)?.isComplete();

      // The final values for the last leg are stored in dividendPerHorse
      // and not in the last dividendPerHorsePerLeg, which only contains the
      // preliminary values. Therefore, if we are showing the last leg
      // and it is complete, we overwrite dividendPerHorse with
      // gameInformation.getDividendPerHorse()
      if (isLastLegAndIsComplete) {
        dividendPerHorse = api.gameInformation.getDividendPerHorse();
      }

      $conditions
        .find('.ranking-dividends-per-horse-header')
        .text(
          Text.get('ranking-dividends-per-horse', dividendPerHorseLegNumber),
        );

      const gameRow = api.gameInformation.getRow(dividendPerHorseLegNumber - 1);

      for (let idx = 0; idx < numberOfDividendsPerHorse; idx++) {
        const dividendRow = dividendPerHorse?.getDividendForHorse(idx);

        if (!dividendRow && !gameRow.isScratched(idx)) {
          continue;
        }

        const $row = StickyTemplate.jq(
          'bottom-conditions-ranking-dividend-per-horse-row',
        );
        if (gameRow.isScratched(idx)) {
          $row.find('.start-number').text(idx + 1);
          $row.find('.dividend').text('-');
          $row.css({ opacity: '0.5' });
        } else {
          const startNumberElem = selectedHorses.includes(idx + 1)
            ? $('<span>', { text: idx + 1, class: 'selected-item' })
            : $('<span>', { text: idx + 1 });
          $row.find('.start-number').append(startNumberElem);
          // ATG returns values greater than 200000 as 0
          // Rikstoto returns them as exactly 200000
          if (
            (IS_SE_SITE && dividendRow.getSum() === 0) ||
            (IS_NO_SITE && dividendRow.getSum() === 200_000)
          ) {
            // When we receive these values, we render them as >200000
            // However, for the last leg, they should render has Jackpot if leg is complete
            // and as >200000/jackpot if leg is incomplete
            $row
              .find('.dividend')
              .text(
                isLastLegAndIsComplete
                  ? 'Jackpot'
                  : `> ${formatMoney(200_000, dividendRow.getCurrency())}${isLastLeg ? ' / Jackpot' : ''}`,
              );
          } else {
            $row
              .find('.dividend')
              .text(
                formatMoney(dividendRow.getSum(), dividendRow.getCurrency()),
              );
          }
        }
        $dividendsPerHorseTableBody.append($row);
      }
    }
  }

  if (
    preliminaryDividendPerHorse.length > 0 &&
    settings.showCalculatedDividend(getStore().getState())
  ) {
    const $preliminaryDividendPerHorseTableBody =
      $preliminaryDividendPerHorse.find('table tbody');
    $preliminaryDividendPerHorseTableBody.empty();

    $preliminaryDividendPerHorse.show();

    $conditions
      .find('.ranking-preliminary-dividend-per-horse-header')
      .text(Text.get('ranking-preliminary-dividend-per-horse'));

    $conditions.find('.ranking-preliminary-dividend-per-horse-header').append(
      createHelpIcon({
        header: Text.get('help-ranking-preliminary-dividend-header'),
        body: Text.get('help-ranking-preliminary-dividend-body'),
      }),
    );

    const transposed = [];
    allHorses.forEach((startNumber, i) => {
      transposed[startNumber - 1] = i;
    });
    for (let idx = 0; idx < preliminaryDividendPerHorse.length; idx++) {
      const dividendRow = preliminaryDividendPerHorse[transposed[idx]];

      if (!dividendRow) {
        continue;
      }

      const $row = StickyTemplate.jq(
        'bottom-conditions-ranking-preliminary-dividend-per-horse-row',
      );
      const startNumberElem = selectedHorses.includes(idx + 1)
        ? $('<span>', { text: idx + 1, class: 'selected-item' })
        : $('<span>', { text: idx + 1 });
      $row.find('.start-number').append(startNumberElem);
      const gameRow = api.gameInformation.getRow(dividendPerHorseLegNumber - 1);
      if (gameRow.isScratched(idx)) {
        $row.find('.start-number').text(idx + 1);
        $row.find('.dividend').text('-');
        $row.css({ opacity: '0.5' });
      } else {
        $row
          .find('.dividend')
          .text(formatMoney(dividendRow.getSum(), dividendRow.getCurrency()));
      }
      $preliminaryDividendPerHorseTableBody.append($row);
    }
  }

  return true;
}

export default function handleResultUpdates(
  api,
  $conditions,
  toggleResultRowHandler,
  showAllResultsHandler,
  hideAllResultsHandler,
) {
  // Hide initially, will be shown depending on category of bet type and
  // if there are results published for this game yet.
  $conditions.find('.fiveplus-results').hide();
  $conditions.find('.odds').hide();
  $conditions.find('.winners-and-values').hide();
  $conditions.find('.dividends').hide();
  $conditions.find('.dividends-per-horse').hide();
  $conditions.find('.preliminary-dividend-per-horse').hide();

  if (!api.resultInformation) {
    return false;
  }

  const resultType = api.resultInformation.getResultType();

  if (['Double', 'Trio'].includes(resultType)) {
    return handleResultsSingleRaceBetType(
      api,
      $conditions,
      toggleResultRowHandler,
      showAllResultsHandler,
      hideAllResultsHandler,
    );
  } else if (resultType === 'FivePlus') {
    return handleResultsFivePlus(
      api,
      $conditions,
      toggleResultRowHandler,
      showAllResultsHandler,
      hideAllResultsHandler,
    );
  } else {
    return handleResultsMultiRaceBetType(
      api,
      $conditions,
      toggleResultRowHandler,
      showAllResultsHandler,
      hideAllResultsHandler,
    );
  }
}
